export default [
  {
    label: "供应",
    value: "supply",
    color: "#00C853"
  },
  {
    label: "求购",
    value: "spread",
    color: "#0091EA"
  },
  {
    label: "招聘",
    value: "recruitment",
    color: "#FF6D00"
  },
  {
    label: "求助",
    value: "help",
    color: "#AA00FF"
  },
  {
    label: "悬赏",
    value: "reward",
    color: "#FFAB00"
  }
];
